import { Notification } from "../types/notification";
import { ENV } from "../utils/constants";
import api from "./api";

export const listNotification = async (): Promise<Notification[]> => {
  const response = await api.get(`notification-${ENV}/notification`);

  return response.data.content;
};

export const listNotificationById = async (
  id: string
): Promise<Notification> => {
  const response = await api.get(`notification-${ENV}/notification/${id}`);

  return response.data.content;
};

export const readNotification = async (id: string): Promise<any> => {
  const response = await api.put(`notification-${ENV}/notification/read/${id}`);

  return response.data.content;
};
